import { Filder } from "@/project/documents/types"

export type DocumentsDeleteState = {
  isOpen: boolean,
  documents: Filder[],
  loading: boolean,
}

export const state: DocumentsDeleteState = {
  isOpen: false,
  documents: [],
  loading: false,
}
